export default __webpack_public_path__ + "static/media/video-1.be93471b.mp4";